import isEmptyObject from '../is-empty-object'
import isObject from '../is-object'

/**
 * Removes all null and empty values from an object.
 * Note: Recursively looking into nested objects and array
 */
function sanitizeObject (fields) {
  return Object.entries(fields).reduce((sanitized, [key, value]) => {
    if (Array.isArray(value)) {
      return { ...sanitized, [key]: value.filter(v => v) }
    } else if (isObject(value)) {
      const nestedFields = sanitizeObject(value)
      if (isEmptyObject(nestedFields)) {
        return sanitized
      }
      return { ...sanitized, [key]: nestedFields }
    } else if (value) {
      return { ...sanitized, [key]: value }
    }
    return sanitized
  }, {})
}

export default sanitizeObject
